import { PositionIdUnit } from '../../services/shipping-form/shipping-form.model';

export interface ProductFromApi {
  PozId: number;
  NamePl: string;
  NameEn: string;
  JednId: number;
  JednName: string;
  JednNamePl: string;
  JednNameEn: string;
  CzyMaterial: boolean;
  DaneOs: boolean;
  Zakres: string;
  SzczegZakres: string;
  DescriptionPl: string;
  DescriptionEn: string;
  PostacElektroniczna: boolean;
  ZbiorDanych: boolean;
  MaKolejnyEgzemplarz: boolean;
  CzyCelWymagany: boolean;
  Form: string;
  PrfxSprId: number;
  PrzygotowywanaAutomatycznie: boolean;
  SkalaDruk: number[];
  IsWebService: boolean;
  IsWebServiceActive: boolean;
}

export interface PaidCategoryFromApi {
  TabId: number;
  TabPl: string;
  TabEn: string;
  NameEn: string;
  DisplayedNamePl: string;
  DisplayedNameEn: string;
  IconName: string;
  Items: ProductFromApi[];
}

export class PaidCategory {
  constructor(
    public tabId: number,
    public displayNamePl: string,
    public displayNameEn: string,
    public iconName: string,
    public products: Product[],
  ) {}

  static fromApiToApp(
    paidCategoryFromApi: PaidCategoryFromApi,
    isPaymentEnabled: boolean,
  ): PaidCategory {
    return new this(
      paidCategoryFromApi.TabId,
      paidCategoryFromApi.DisplayedNamePl,
      paidCategoryFromApi.DisplayedNameEn,
      paidCategoryFromApi.IconName,
      paidCategoryFromApi.Items.map((productFromApi) =>
        Product.fromApiToApp(
          productFromApi,
          paidCategoryFromApi.TabId,
          isPaymentEnabled,
        ),
      ),
    );
  }
}

export class Product {
  constructor(
    public posId: number,
    public namePl: string,
    public nameEn: string,
    public unitId: PositionIdUnit,
    public unitName: string,
    public unitNameEn: string,
    public unitNamePl: string,
    public isMaterial: boolean,
    public personalData: boolean,
    public mapObjectRange: string,
    public mapObjectDetailedRange: string,
    public descriptionPl: string,
    public descriptionEn: string,
    public electronicForm: boolean,
    public dataset: boolean,
    public hasNextSpecimen: boolean,
    public isPurposeRequired: boolean,
    public form: string,
    public casePrefixId: number,
    public categoryId: number,
    public preparedAutomatically: boolean,
    public availableMapScalesDenominators: number[],
    public isWebService: boolean,
    public isWebServiceActive: boolean,
  ) {}

  static fromApiToApp(
    productFromApi: ProductFromApi,
    categoryId: number,
    isPaymentEnabled: boolean,
  ): Product {
    const preparedAutomatically =
      productFromApi.PrzygotowywanaAutomatycznie && isPaymentEnabled;
    return new this(
      productFromApi.PozId,
      `${productFromApi.NamePl}${preparedAutomatically ? ' *' : ''}`,
      `${productFromApi.NameEn}${preparedAutomatically ? ' *' : ''}`,
      productFromApi.JednId,
      productFromApi.JednName,
      productFromApi.JednNameEn,
      productFromApi.JednNamePl,
      productFromApi.CzyMaterial,
      productFromApi.DaneOs,
      productFromApi.Zakres,
      productFromApi.SzczegZakres,
      productFromApi.DescriptionPl,
      productFromApi.DescriptionEn,
      productFromApi.PostacElektroniczna,
      productFromApi.ZbiorDanych,
      productFromApi.MaKolejnyEgzemplarz,
      productFromApi.CzyCelWymagany,
      productFromApi.Form,
      productFromApi.PrfxSprId,
      categoryId,
      preparedAutomatically,
      productFromApi.SkalaDruk,
      productFromApi.IsWebService,
      productFromApi.IsWebServiceActive,
    );
  }
}
